<template>
	<main class="vx-row justify-center">
		<div class="vx-col w-full md:w-1/2 ">
			<vx-card>
				<p class="mb-4"><strong>Email</strong></p>
				<vs-input
					class="w-full mb-6"
					v-model="email"
				/>
				<div v-if="interval > 0" class="text-right mb-2">
					<strong>{{ formatClock(interval) }} detik</strong>
				</div>
				<vs-button :disabled="disabled" @click.prevent="resendEmail" class="rounded-lg w-full mb-4">
					<strong>Kirim Link Verifikasi</strong>
				</vs-button>
				<p class="text-center">
					<router-link to="/profile"><small>Kembali ke profile</small></router-link>
				</p>
			</vx-card>
		</div>
	</main>
</template>

<script>
	import {mapState} from 'vuex'

	export default {
		methods: {
			formatClock(time) {
				if(time.toString().length > 1) {
					return time
				}

				return `0${time}`
			},
			resendEmail() {
				if(!this.email) {
					this.$vs.notify({
						title: 'Harap masukan email anda',
						text: '',
						color: 'warning',
						position: 'top-right'
					})

					return false
				}

				this.$vs.loading()
				this.$store.dispatch('auth/resendEmail', this.email)
				.then(res => {
					this.interval = 60
					this.disabled = true
					const startTimer = setInterval(() => {
						if(this.interval < 1) {
							clearInterval(startTimer)
							this.disabled = false
						}
						else {
							this.interval--
						}
					}, 1000)

					this.$vs.loading.close()
					this.$vs.notify({
						title: res.message,
						text: 'Silahkan cek email anda',
						color: 'success',
						position: 'top-right'
					})
				})
				.catch(e => {
					this.$vs.loading.close()
					this.showError(e)

					return false
				})
			}
		},
		computed: {
			...mapState('auth', ['profile'])
		},
		data: () => ({
			interval: 0,
			email: null,
			disabled: false
		}),
		created() {
			this.email = this.profile.email
		}
	}
</script>